import { serverTimestamp, addDoc, collection, setDoc, doc, getDoc, query, onSnapshot, orderBy, where, limit, startAfter, getDocs } from "firebase/firestore";
import { getCurrentUserUID, db, getCompanyId, sendError } from "./firebase";

import { Badge } from '@awesome-cordova-plugins/badge';
import { Capacitor } from "@capacitor/core";

var snapshotListener: Function | null = null;
const listeners: CallableFunction[] = [];
var lastSnapshotList: any[] = [];

var lastItem: any = undefined;

export function registerSmsGroupSnapshotListener() {
    if (snapshotListener !== null) {
        return;
    }
    const q = query(collection(db, 'companies/' + getCompanyId() + '/sms'), orderBy("updated", "desc"), limit(30));
    //console.log("register registerSmsGroupSnapshotListener");
    snapshotListener = onSnapshot(q, (data: any) => {
        var list: any[] = [];
         var unreadCounter = 0;
        data.forEach(function (doc: any) {
            const d = doc.data();
             if (d.new) {
                 unreadCounter++;
             }
            //dodaje na początku
            list.push({ ...d, id: doc.id });
        });
        if(Capacitor.isNativePlatform()){
            Badge.set(unreadCounter);
        }
       
        lastSnapshotList = list;
        listeners.forEach(callback => {
            callback(list);
        });
        if (lastItem === undefined) {
            lastItem = data.docs[data.docs.length - 1];
        }
    }, (err) => {
        console.log("onSmsGroupChange error => " + err.message);
        sendError(err.message);
    })
}

export async function unregisterSmsGroupSnapshotListener() {
    if (snapshotListener !== null) {
        //console.log("unregister smsGroupSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addSmsGroupListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshotList.length > 0) {
        callback(lastSnapshotList);
    }
}

export async function updateSmsGroup(data: any) {
    try {
        await setDoc(doc(db, 'companies/' + getCompanyId() + '/sms/', data.id), data, { merge: true });
    } catch (error) {
        console.error(error);
        sendError("Nie mozna poprawić SmsGroup!");
    }
}

export async function getMoreSmsGroups() {

    var list: any[] = [];
    if (lastItem !== undefined) {
        const q = query(collection(db, 'companies/' + getCompanyId() + '/sms'), orderBy("updated", "desc"), startAfter(lastItem), limit(30));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const d = doc.data();
            list.push({ ...d, id: doc.id });
        });
        if (querySnapshot.docs.length > 0) {
            lastItem = querySnapshot.docs[querySnapshot.docs.length - 1];
        } else {
            lastItem = undefined;
        }
    }
    return list;
}


